import { render, staticRenderFns } from "./TaskTasktempHistoricDetailOld.vue?vue&type=template&id=df21cf1e"
import script from "./TaskTasktempHistoricDetailOld.vue?vue&type=script&lang=js"
export * from "./TaskTasktempHistoricDetailOld.vue?vue&type=script&lang=js"
import style1 from "./TaskTasktempHistoricDetailOld.vue?vue&type=style&index=1&id=df21cf1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports